module.exports = __webpack_public_path__ + "static/Underdown4-1e4e17fd4eb036fb3dc8b6c57cb60273.png";